import UserService from "../../services/user"
import { useState } from "react"
import Input from "../common/Input"
import { useLeague } from "../../context/useLeague"
import useNotyf from '../../context/useNotify'
import { useUser } from "../../context/useUser"

const LoginForm = ({ modalOpen, toggleModal, toggleLogin }) => {

  const { getLeagueById } = useLeague()
  const { setUser } = useUser()
  const notyf = useNotyf()

  const [errMsg, setErrMsg] = useState("")
  const [isLoading, setIsLoading] = useState(false)

  const [username, setUsername] = useState("")
  const [password, setPassword] = useState("")

  const login = async () => {
    if (isLoading) {
      return
    }
    setIsLoading(true)
    try {
      const { user } = await UserService.login({ username, password })
      setPassword('')
      setUser(user)
      notyf.success("Welcome back, you are now logged in!")
      if (user.leagues.length) {
        getLeagueById(user.leagues[0])
      }
    } catch (err) {
      console.log(err);
      notyf.error("Invalid username or password. Please try again.")
    } finally {
      setIsLoading(false)
    }
 }

  const handleSubmit = async (e) => {
    e.preventDefault()
    if (!validateForm()) {
      return
    }

    await login(username, password)
    toggleModal()
  }

  const validateForm = () => {
    if (!username || !password) {
      setErrMsg("Both email and password are required")
      return false
    }
    return true
  }

  const handleSwitchForm = (e) => {
    e.preventDefault()
    toggleLogin()
  }

  return (
    <div className="modal-overlay">
      <div
        className=" modal  "
        style={{ display: `${modalOpen ? "block" : "none"}` }}
      >
        <div className="modal-dialog">
          <div className="modal-content bg-dark">
            <div className="modal-header">
              <h5 className="modal-title">Login</h5>
              <button
                type="button"
                className="btn btn-secondary"
                onClick={toggleModal}
              >
                Close
              </button>
            </div>
            <div className=" modal-body ">
              <form className="d-flex flex-column" onSubmit={handleSubmit}>
                {/*<Input label="Email" id="email" placeholder="Enter email" type="email" value={email} setValue={setEmail} />*/}
                <Input
                  label="Username"
                  id="username"
                  placeholder="Enter username"
                  type="text"
                  value={username}
                  setValue={setUsername}
                />
                <Input
                  label="Password"
                  id="password"
                  placeholder="Enter password"
                  type="password"
                  value={password}
                  setValue={setPassword}
                />
                <button
                  type="submit"
                  className="btn btn-primary btn-block  mt-4"
                >
                  Login
                </button>

                <p className="text-danger mt-2">{errMsg}</p>

                <label htmlFor="confirmPassword" className="text-light">
                  Don't have an account?
                </label>
                <button
                  className="btn btn-secondary btn-block"
                  type="button"
                  onClick={toggleLogin}
                >
                  Sign Up
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default LoginForm
